<template>
  <!-- D: 얼럿은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다 -->
  <!-- CYB_PC_QU_01_02 -->
  <div id="CYB_PC_QU_01_02" class="alert" data-alert>
    <div class="dialog">
      <div class="dialog-content">
        <div class="text-wrap ac">
          <strong class="subject">주문 완료</strong>
          <p class="text">내용 확인 후 주문 접수 예정입니다.</p>
        </div>
      </div>
      <div class="dialog-footer">
        <div class="c-btn-area">
          <button type="button" class="c-button type-primary" data-alert-close>
            <span>확인</span>
          </button>
        </div>
      </div>
    </div>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>
<script setup name="orderComplete"></script>
